import script from "./AddDetachedNoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDetachedNoteForm.vue?vue&type=script&setup=true&lang=js"

import "./AddDetachedNoteForm.vue?vue&type=style&index=0&id=a9a43cd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9a43cd0"]])

export default __exports__